import { createSlice } from "@reduxjs/toolkit";

export interface ISharedDrawerState {
    open: boolean;
}

export const sharedDrawerInitialState: ISharedDrawerState = {
    open: false
};

export const SharedDrawerSlice = createSlice({
    name: "sharedDrawer",
    initialState: sharedDrawerInitialState,
    reducers: {
      openDrawer: () => ({
        open: true
      }),
      closeDrawer: () => ({
        open: false
      })
    }
});

export const SharedDrawerActions = SharedDrawerSlice.actions;
export const SharedDrawerReducer = SharedDrawerSlice.reducer;